import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import EventsStore from '../../stores/EventsStore'
import { Button, Form, Grid, Header, Icon, Modal, Pagination, Table } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Input from '../../components/Forms/Input'
import LoadingWrapper from '../../components/LoadingWrapper'
import AuthenticationStore from '../../stores/AuthenticationStore'
import UsersStore from '../../stores/UsersStore'
import Dropdown from '../../components/Forms/Dropdown'
import Toast from '../../components/Toast'
import { withRouter } from 'react-router'

@inject('eventsStore', 'authenticationStore')
@withRouter
@observer
class EventsScreen extends Component {
  static propTypes = {
    eventsStore: PropTypes.instanceOf(EventsStore).isRequired,
    authenticationStore: PropTypes.instanceOf(AuthenticationStore),
    location: PropTypes.object
  }

  state = {
    hideSearch: false,
    listInspectors: [],
    canQueryInspector: false,
    deleteEvent: null,
    showModal: false,
    canDelete: false
  }

  constructor (props) {
    super(props)
    window.document.title = 'Rapports d\'inspections'
    const { authenticationStore } = this.props
    this.usersStore = new UsersStore()
    this.state.canQueryInspector = authenticationStore.getRoleForControllerAction('events', ['read_all', 'read_limited'])
    this.state.canDelete = authenticationStore.getRoleForControllerAction('events', ['delete'])
  }

  componentDidMount () {
    const { eventsStore } = this.props
    eventsStore.clearFilters()
    const searchVariables = new URLSearchParams(this.props.location.search)
    if (searchVariables.has('clientId')) {
      this.setState({ hideSearch: true })
      eventsStore.set('_tmpQuery.client_id', searchVariables.get('clientId'))
      eventsStore.sendFilters()
    }
    eventsStore.loadAll()
    this.usersStore.getInspectors().then(() => {
      const { users } = this.usersStore
      this.setState({
        listInspectors: users.map(user => ({
          value: user.id, text: user.fullName
        }))
      })
    })
  }

  displayModal (showModal) {
    this.setState({ showModal })
  }

  deleteEventConfirmation (deleteEvent) {
    this.setState({
      showModal: true,
      deleteEvent
    })
  }

  handleConfirmEvent (event) {
    const { eventsStore } = this.props
    eventsStore.confirmEvent(event.id).then(() => {
      eventsStore.loadAll()
    })
  }

  handleDeleteEvent = () => {
    const { eventsStore } = this.props
    const { deleteEvent } = this.state
    this.displayModal(false)

    if (deleteEvent) {
      eventsStore.deleteEvent(deleteEvent.id).then(() => {
        eventsStore.loadAll()
      }).catch(e => console.error)
      this.setState({ deleteEvent: null })
    }
  }

  changePage = (page) => {
    const { eventsStore } = this.props
    eventsStore.changePage(page.activePage)
    eventsStore.loadAll()
  }

  handleSendFilters = () => {
    const { eventsStore } = this.props
    eventsStore.sendFilters()
    eventsStore.loadAll()
  }

  handleClearFilters = () => {
    const { eventsStore } = this.props
    eventsStore.clearFilters()
    eventsStore.loadAll()
  }

  render () {
    const { eventsStore, authenticationStore } = this.props
    const { listInspectors, canQueryInspector, canDelete, showModal, hideSearch } = this.state
    const { paging, events, isLoading, toasts } = eventsStore
    return (
      <>
        <Header as='h2'>Rapports d'inspections</Header>
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Toast toasts={toasts} />
        <Modal open={showModal} onClose={() => this.displayModal(false)}>
          <Modal.Header>Supprimer l'inspection</Modal.Header>
          <Modal.Content>Êtes-vous sûr de vouloir supprimer l'inspection?</Modal.Content>
          <Modal.Actions>
            <Button content='Annuler' onClick={() => this.displayModal(false)} />
            <Button color='google plus' content='Supprimer' onClick={this.handleDeleteEvent} />
          </Modal.Actions>
        </Modal>
        <Grid>
          {!hideSearch &&
            <Grid.Row>
              <Grid.Column>
                <Header as='h3'>Filtrer par:</Header>
                <Form>
                  <Form.Group widths='equal'>
                    <Input name='_tmpQuery.PK_Number' label='Code' store={eventsStore} />
                    <Input name='_tmpQuery.name' label='Nom Compagnie' store={eventsStore} />
                    <Input name='_tmpQuery.contact_name' label='Nom Contact' store={eventsStore} />
                    <Input name='_tmpQuery.address' label='Adresse' store={eventsStore} />
                  </Form.Group>
                  {canQueryInspector &&
                    <Form.Group widths='equal'>
                      <Dropdown name='_tmpQuery.user_id' label='Technicien' fluid search selection options={listInspectors} store={eventsStore} />
                      <Dropdown
                        name='_tmpQuery.status' fluid selection options={[
                          { value: 'CREATED', text: 'En attente d\'inspection' },
                          { value: 'STARTED', text: 'Débuté / En retard' },
                          { value: 'EXPIRED', text: 'En retard' },
                          { value: 'WAITING_EVALUATION', text: 'En attente d\'évaluation' },
                          { value: 'COMPLETED', text: 'Terminé' },
                          { value: 'SCHEDULED', text: 'Planifié non confirmé' }
                        ]} label='Statut' store={eventsStore}
                      />
                    </Form.Group>}
                  <Button primary onClick={this.handleSendFilters}>Filtrer</Button>
                  <Button primary onClick={this.handleClearFilters}>Effacer</Button>
                </Form>
              </Grid.Column>
            </Grid.Row>}

          <Grid.Row>
            <Grid.Column>
              {!!paging.Events && <Pagination
                onPageChange={(e, data) => this.changePage(data)}
                totalPages={paging.Events.pageCount}
                activePage={paging.Events.page}
                                  />}
              {!!events.length &&
                <Table celled>
                  <Table.Header key='header'>
                    <Table.Row>
                      <Table.HeaderCell>Technicien</Table.HeaderCell>
                      <Table.HeaderCell>Client</Table.HeaderCell>
                      <Table.HeaderCell>Adresse</Table.HeaderCell>
                      <Table.HeaderCell>Équipement</Table.HeaderCell>
                      <Table.HeaderCell>Date inspection</Table.HeaderCell>
                      <Table.HeaderCell>Temps restant</Table.HeaderCell>
                      <Table.HeaderCell>Statut</Table.HeaderCell>
                      <Table.HeaderCell>Actions</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body key='body'>
                    {events.map(event => {
                      return (
                        <Table.Row key={`event_${event.id}`}>
                          <Table.Cell>
                            {event.user.fullName}
                          </Table.Cell>
                          <Table.Cell>
                            {event.client.name}
                          </Table.Cell>
                          <Table.Cell>
                            {event.clients_addresses_equipment.clients_address.address.fullAddress}
                          </Table.Cell>
                          <Table.Cell>
                            {event.clients_addresses_equipment.equipment.name}
                          </Table.Cell>
                          <Table.Cell>
                            {moment(event.date_start).format('HH:mm DD-MM-YYYY')}
                          </Table.Cell>
                          <Table.Cell>
                            {event.remainingTime}
                          </Table.Cell>
                          <Table.Cell>
                            {event.statusName}
                          </Table.Cell>
                          <Table.Cell>
                            {(authenticationStore.isAdmin() || authenticationStore.getRoleForControllerAction('events', 'create')) &&
                              <>
                                {event.status === 'SCHEDULED' &&
                                  <Icon
                                    link
                                    name='check'
                                    onClick={() => { this.handleConfirmEvent(event) }}
                                  />}
                                {event.status === 'WAITING_EVALUATION' &&
                                  <Link to={`/events/review/${event.id}?view=summary`}>
                                    <Icon
                                      link
                                      name='eye'
                                    />
                                  </Link>}
                                {event.status !== 'WAITING_EVALUATION' &&
                                  <Link to={`/events/event/${event.id}`}>
                                    <Icon
                                      link
                                      name='pencil'
                                    />
                                  </Link>}
                                {
                                  ['gicleur', 'alarme', 'extincteur'].includes(event.clients_addresses_equipment.equipment.code) &&
                                  event.status === 'WAITING_EVALUATION' &&
                                    <a href={`/api/archives/downloadpdf/${event.id}`} target='_blank' rel='noreferrer'>
                                      <Icon name='certificate' link />
                                    </a>
                                }
                              </>}
                            {!(authenticationStore.isAdmin() || authenticationStore.getRoleForControllerAction('events', 'create')) && event.status !== 'WAITING_EVALUATION' &&
                              <Link to={`/events/event/${event.id}`}>
                                <Icon
                                  link
                                  name='pencil'
                                />
                              </Link>}
                            {!(authenticationStore.isAdmin() || authenticationStore.getRoleForControllerAction('events', 'create')) && ['STARTED', 'EXPIRED'].includes(event.status) &&
                              <Link to={`/events/submit/${event.id}`}>
                                <Icon
                                  link
                                  name='check'
                                />
                              </Link>}
                            {canDelete && event.status !== 'COMPLETED' &&
                              <Icon
                                color='red' link name='trash'
                                onClick={() => { this.deleteEventConfirmation(event) }}
                              />}

                          </Table.Cell>
                        </Table.Row>
                      )
                    })}
                  </Table.Body>
                </Table>}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    )
  }
}

export default EventsScreen
